/**
 * Creates a key-value map of legals where the key is the slug
 * and the value is the legal item.
 *
 * @param legals Array of legal items.
 * @returns A key value map of legals.
 */
export default function createLegalsMap(legals) {
    const map = {};
    for (const legal of legals) {
        map[legal.slug] = legal;
    }
    return map;
}
